module.exports = __webpack_public_path__ + "img/coffeetogo.da7cffd3.jpg";